import React, { useCallback, useState } from 'react';
import { Routes, Route } from "react-router-dom";
import Home from './pages/home/Home';
import Login from './pages/login/Login';

function App() {
  return (
    <div className="h-screen w-screen">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
      </Routes>
    </div>
  );
}

export default App;
